import {
  hm5GlobalReleaseConstants,
  addHM5GlobalReleaseConstants,
  editHM5GlobalReleaseConstants,
} from "../_redux-constants";

export function hm5GlobalReleaseReducer(
  state = {
    hm5GlobalReleaseLoading: false,
    hm5GlobalReleaseData: null,
    hm5GlobalReleaseError: null,

    addHM5GlobalReleaseLoading: false,
    addHM5GlobalReleaseData: null,
    addHM5GlobalReleaseError: null,

    editHM5GlobalReleaseLoading: false,
    editHM5GlobalReleaseData: null,
    editHM5GlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case hm5GlobalReleaseConstants.HM5_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        hm5GlobalReleaseLoading: true,
        hm5GlobalReleaseData: null,
        hm5GlobalReleaseError: null,
        addHM5GlobalReleaseLoading: false,
        addHM5GlobalReleaseData: null,
        addHM5GlobalReleaseError: null,
      });
    case hm5GlobalReleaseConstants.HM5_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        hm5GlobalReleaseLoading: false,
        hm5GlobalReleaseData: action.data,
      });
    case hm5GlobalReleaseConstants.HM5_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        hm5GlobalReleaseLoading: false,
        hm5GlobalReleaseData: null,
        hm5GlobalReleaseError: action.error,
      });

    case addHM5GlobalReleaseConstants.ADD_HM5_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addHM5GlobalReleaseLoading: true,
        addHM5GlobalReleaseData: null,
        addHM5GlobalReleaseError: null,
      });
    case addHM5GlobalReleaseConstants.ADD_HM5_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addHM5GlobalReleaseLoading: false,
        addHM5GlobalReleaseData: action.data,
      });
    case addHM5GlobalReleaseConstants.ADD_HM5_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addHM5GlobalReleaseLoading: false,
        addHM5GlobalReleaseData: null,
        addHM5GlobalReleaseError: action.error,
      });

    case editHM5GlobalReleaseConstants.EDIT_HM5_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editHM5GlobalReleaseLoading: true,
        editHM5GlobalReleaseData: null,
        editHM5GlobalReleaseError: null,
      });
    case editHM5GlobalReleaseConstants.EDIT_HM5_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editHM5GlobalReleaseLoading: false,
        editHM5GlobalReleaseData: action.data,
      });
    case editHM5GlobalReleaseConstants.EDIT_HM5_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editHM5GlobalReleaseLoading: false,
        editHM5GlobalReleaseData: null,
        editHM5GlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
